import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { REQUEST, deleteModelSuccess, deleteModelFailure } from '../../actions/models/delete';
import { fetchRequest as fetchModels } from '../../actions/models/list';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

// Worker saga for deleting a model
function* deleteModel(action) {
  try {
    // Get headers from the utility function
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Make the DELETE request to delete the model
    const response = yield call(
      axios.delete,
      `${config.API_URL}/pipelines/${action.payload}`,
      { headers }
    );
    
    // Dispatch success action with the response data
    yield put(deleteModelSuccess(response.data));
    
    // Add success snackbar message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Pipeline deleted successfully' });
    
    // Refresh the models list to reflect the deletion
    yield put(fetchModels({
      page: 1,
      per_page: 10
    }));
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Delete model saga error:', error);

    let errorMessage;
    if (error?.response?.status === 404) {
      errorMessage = `Model with ID ${action.payload} not found or you don't have permission to delete it`;
    } else if (error?.response?.status === 400) {
      errorMessage = error.response.data?.status || 'Cannot delete model that is currently in training';
    } else {
      errorMessage = extractErrorMessage(error);
    }

    // Dispatch global error action
    yield put(ErrorAction(error));
    
    // Dispatch failure action with the error
    yield put(deleteModelFailure(errorMessage));
    
    return {
      success: false,
      error: errorMessage
    };
  }
}

// Watcher saga for model deletion
export function* watch() {
  yield takeLatest(REQUEST, deleteModel);
} 